// import { useLocation } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import axios from 'axios';
// import './BlogDetailsStyled.css';

// const BlogDetailsStyled = () => {
//   const location = useLocation();
//   const { id } = location.state || {};
//   const [blog, setBlog] = useState(null);
//   const [showForm, setShowForm] = useState(false); // <-- add this


//   useEffect(() => {
//     if (id) {
//       axios.get(`/api/blogs/${id}`)
//         .then(res => setBlog(res.data))
//         .catch(err => console.error(err));
//     }
//   }, [id]);

//   if (!blog) return <p className="loading">Loading blog...</p>;

//   return (
//     <div className="blog-details-wrapper">
//       {/* MAIN IMAGE */}
//       {blog.imagePath && (
//         <img
//           src={`/uploads/${blog.imagePath}`}
//           alt="Main"
//           className="main-image"
//         />
//       )}

//       {/* TITLE */}
//       <h1 className="blog-title">{blog.title}</h1>

//       {/* DESCRIPTION */}
//       {/* <p className="blog-description">{blog.description}</p> */}

//       {/* EXTRA IMAGES */}
//       {blog.extraImages && blog.extraImages.length > 0 && (
//         <div className="extra-images-section">
//           {blog.extraImages.map((img, idx) => (
//             <img
//               key={idx}
//               src={`/uploads/${img}`}
//               alt={`Extra ${idx + 1}`}
//               className="extra-image"
//             />
//           ))}
//         </div>
//       )}

//  <p className="blog-description">{blog.description}</p>
//       {/* SUBPARTS */}
//       {blog.subParts?.length > 0 && (
//         <>
//           <h2 className="specs-heading">Subparts:</h2>
//           <ul className="specs-list">
//             {blog.subParts.map((part, idx) => (
//               <li key={idx}>{part}</li>
//             ))}
//           </ul>
//         </>
//       )}
// {blog && (
//   <div className="buy-product-section">
//     <button 
//       className="buy-button"
//       onClick={() => setShowForm(true)} // <-- this works now
//     >
//       Buy {blog.title}
//     </button>
//   </div>
// )}

      
//     </div>
//   );
// };

// export default BlogDetailsStyled;



// import { useLocation, useNavigate } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import axios from 'axios';
// import './BlogDetailsStyled.css';

// const BlogDetailsStyled = () => {
//   const location = useLocation();
//   const navigate = useNavigate(); // <-- add navigate
//   const { id } = location.state || {};
//   const [blog, setBlog] = useState(null);

//   useEffect(() => {
//     if (id) {
//       axios.get(`/api/blogs/${id}`)
//         .then(res => setBlog(res.data))
//         .catch(err => console.error(err));
//     }
//   }, [id]);

//   if (!blog) return <p className="loading">Loading blog...</p>;

//   return (
//     <div className="blog-details-wrapper">
//       {blog.imagePath && (
//         <img
//           src={`/uploads/${blog.imagePath}`}
//           alt="Main"
//           className="main-image"
//         />
//       )}
//       <h1 className="blog-title">{blog.title}</h1>
//       <p className="blog-description">{blog.description}</p>

//       {blog.extraImages?.length > 0 && (
//         <div className="extra-images-section">
//           {blog.extraImages.map((img, idx) => (
//             <img
//               key={idx}
//               src={`/uploads/${img}`}
//               alt={`Extra ${idx + 1}`}
//               className="extra-image"
//             />
//           ))}
//         </div>
//       )}

//       {blog.subParts?.length > 0 && (
//         <>
//           <h2 className="specs-heading">Subparts:</h2>
//           <ul className="specs-list">
//             {blog.subParts.map((part, idx) => (
//               <li key={idx}>{part}</li>
//             ))}
//           </ul>
//         </>
//       )}

//       {blog && (
//         <div className="buy-product-section">
//           <button
//             className="buy-button"
//             onClick={() => navigate('/ProductApplicationForm', { state: { id: blog._id } })} 
//           >
//             Buy {blog.title}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BlogDetailsStyled;


import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import './BlogDetailsStyled.css';

const BlogDetailsStyled = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    if (id) {
      axios.get(`/api/blogs/${id}`)
        .then(res => setBlog(res.data))
        .catch(err => console.error(err));
    }
  }, [id]);

  if (!blog) return <p className="loading">Loading blog...</p>;

  return (
    <div className="blog-details-wrapper">
      {/* Product title at the very top */}
      <h1 className="blog-title">{blog.title}</h1>

      {/* Main image below the title */}
      {blog.imagePath && (
        <img
          src={`/uploads/${blog.imagePath}`}
          alt="Main"
          className="main-image"
        />
      )}

      <p className="blog-description">{blog.description}</p>

      {blog.extraImages?.length > 0 && (
        <div className="extra-images-section">
          {blog.extraImages.map((img, idx) => (
            <img
              key={idx}
              src={`/uploads/${img}`}
              alt={`Extra ${idx + 1}`}
              className="extra-image"
            />
          ))}
        </div>
      )}

      {blog.subParts?.length > 0 && (
        <>
          <h2 className="specs-heading">Subparts:</h2>
          <ul className="specs-list">
            {blog.subParts.map((part, idx) => (
              <li key={idx}>{part}</li>
            ))}
          </ul>
        </>
      )}

      <div className="buy-product-section">
        <button
          className="buy-button"
          onClick={() => navigate('/ProductApplicationForm', { state: { id: blog._id } })}
        >
          Buy {blog.title}
        </button>
      </div>
    </div>
  );
};

export default BlogDetailsStyled;
